const mapDisabled = (items, prioritizedItems) => items.map((item) => {
  if (prioritizedItems.find(x => x.id === item.id)) {
    return {
      ...item,
      disabled: true,
    };
  }

  return item;
});

export { mapDisabled };
